import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    // recorder: true,
    // isHello:false,
    exerciseKey: "/img/FriendsPlus/Page25/Demo/Key1.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter: true,
    maxLength: 3,
    hiddenNewWords:true,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted black",
      textAlign: "center",
    },
    inputSize: 60,
    textareaStyle: { width: 800, border: "2px solid black" },
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Đang cập nhật</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Quan sát hình rồi nhập số đo góc vào chỗ chấm.</span>
        <video src="Audios/guide/p25_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>1</b>
        	</div>
        		Nêu số đo góc (theo mẫu).
        </div> 
        <div style='position:relative'> 
              <div style='display:flex'> 
                <img src="img/FriendsPlus/Page25/Demo/2.jpg" style="height:8cm;margin:10px 40px"/>
                <div>
                <table style="border-collapse: collapse; width: 100%; max-width: 600px; margin: 20px auto;">

                    <tr style="border-color:red">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; background-color: #0074D9">Góc</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">Số đo góc</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh A, cạnh AB, AD</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;"> <span style='color:white'>2</span>90 °</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh B, cạnh BA, BC</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh C, cạnh CB, CD</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>
                    <tr style="">
                      <td style="width:400px;border: 1px solid black; padding: 10px; text-align: center; ">Góc đỉnh D, cạnh DA, DC</td>
                      <td style="width:200px;border: 1px solid black; padding: 10px; text-align: center;">#</td>
                    </tr>


                  </table>
                </div>              
              </div>
              <div style='position:absolute;top:147px;left:911px;width:4cm'>
                  °
              </div>
              <div style='position:absolute;top:205px;left:911px;width:4cm'>
                  °
              </div>
              <div style='position:absolute;top:263px;left:911px;width:4cm'>
                  °
              </div>
        </div>
        
            
            
            
        `,
        answer: ["60", "90", "120"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page25/Demo/Key2.png",
    component: T6,
    hiddenNewWords:true,
    isHiddenCheck: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Tra cứu</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>- Di chuyển thước đo góc đến vị trí sao cho tâm của thước trùng với đỉnh O của góc; cạnh OB nằm trên đường kính của nửa hình tròn của thước.<br>
        - Sau đó hãy nhập toạ độ để xoay thước (nếu cần) sao cho cạnh OA đi qua một vạch trên nửa đường tròn của thước.
        </span>
        <video src="Audios/guide/p25_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "700px",
        inputTop: "188px",
        ResultProtractor:[
          {
            textResult: 60,
            styleResult:{
              top: -68,
              left:-530
            }
          },
          {
            textResult: 60,
            styleResult:{
              top:129,
              left:-429
            },
          },
          
        ],
        result: [
          {
            id: 0,
            top: 131, // top cây thước sau khi đặt vô hình
            left: -128, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 1,
            top: 130, // top cây thước sau khi đặt vô hình
            left: -131, // left cây thước sau khi đặt vô hình
            rotate: 121,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: { fontSize: 23, borderBottom: "none", textAlign: "end" },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-30px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>2</b>
        	</div>
          Dùng thước đo góc để đo góc đỉnh B; cạnh BA, BC
        </div>
        <div style="position: relative;">
        <img src="/img/FriendsPlus/Page25/Demo/3.jpg"  style="height:8cm;margin-top:50px;ftop:0px;left:0px" >
        
        <div
          style="
            position: absolute;
            left: 65px;
            top: 294px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: -37px;left: 575px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
      
        `,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page25/Demo/Key2.png",
    component: T6,
    hiddenNewWords:true,
    isHiddenCheck: true,
    
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Tra cứu</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span><b>Bước 1</b>: Di chuyển thước đo góc đến vị trí chấm đỏ trên đồng hồ<br>
        <b>Bước 2</b>: Để xoay thước đo góc em có thể chọn một trong hai cách sau:<br>
        - Nháy chuột vào ô số 0, sau đó bấm phím mũi tên lên hoặc xuống trên bàn phím để xoay thước.<br>
        - Nhập số vào ô số 0 để xoay thước.<br>
        <b>Bước 3</b>: Bấm vào nút Xác nhận để hiển thị kết quả số đo góc. Nếu đặt thước sai thì máy tính sẽ yêu cầu làm lại.<br>
        - Bỏ nút tra cứu.
        </span>
        <video src="Audios/guide/p25_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "494px",
        inputTop: "433px",
        ResultProtractor:[
          {
            textResult: 90,
            styleResult:{
              top: -443,
              left:-376
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-227,
              left:-156
            },
          },
          {
            textResult: 120,
            styleResult:{
              top: -443,
              left:-80
            }
          },
          {
            textResult: 120,
            styleResult:{
              top:-115,
              left:114
            },
          },
          {
            textResult: 180,
            styleResult:{
              top: -443,
              left:220
            }
          },
          {
            textResult: 180,
            styleResult:{
              top:-443,
              left:220
            },
          },
          {
            textResult: 60,
            styleResult:{
              top: -443,
              left:530
            }
          },
          {
            textResult: 60,
            styleResult:{
              top:-330,
              left:713
            },
          },
          
        ],
        result: [
          {
            id: 0,
            top: 21,
            left: -62,
            rotate: 0,
          },
          {
            id: 1,
            top: 21,
            left: -62,
            rotate: 90,
          },
          {
            id: 2,
            top: 23,
            left: 237,
            rotate: 30,
          },
          {
            id: 3,
            top: 23,
            left: 237,
            rotate: 90,
          },
          {
            id: 4,
            top: 25,
            left: 538,
            rotate: 90,
          },
          {
            id: 5,
            top: 25,
            left: 538,
            rotate: -90,
          },
          {
            id: 6,
            top: 27,
            left: 839,
            rotate: -29,
          },
          {
            id: 7,
            top: 27,
            left: 839,
            rotate: 90,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: { fontSize: 23, borderBottom: "none", textAlign: "end" },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: ` <img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-20px;margin-top:-50px "/> `,
        color: "rgb(3, 103, 181)",
        // star: 1
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; '>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>3</b>
        	</div>
          Dùng thước đo góc để đo các góc được tạo bởi hai kim đồng hồ khi đồng hồ chỉ 3 giờ, 4giờ, 6giờ, 2 giờ.
        </div>
          <div   style="position: absolute; top: 120px; left: 39px;">
            <img   src="/img/FriendsPlus/Page25/Demo/4.jpg"  width='200px'/>
          </div>

          <div  style="position: absolute; top: 226px; left: 132px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>

          <div style="position: absolute; top: 120px; left: 339px;">
            <img src="/img/FriendsPlus/Page25/Demo/5.jpg"  width='200px'/>
          </div>

          <div  style="position: absolute; top: 228px; left: 433px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>

          <div style="position: absolute; top: 120px; left: 639px;">
            <img src="/img/FriendsPlus/Page25/Demo/6.jpg"  width='200px'/>
          </div>
          <div  style="position: absolute; top: 230px; left: 734px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
          </div>
        <div style="position: absolute; top: 120px; left: 939px;">
        <img src="/img/FriendsPlus/Page25/Demo/7.jpg"  width='200px'/>
        </div>

      <div  style="position: absolute; top: 231px; left: 1034px;background-color: red; border-radius: 50%; width:10px;height:10px;z-index:1">
      </div>
        <div
          id="protractor"
          style="position: absolute;top: 298px;left: 77px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
            
        `,
        answer: ["60", "120", "90", "60"],
      },
    ],
  },

  //   3: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P8-E3",
  //     audio: "",
  //     exerciseKey: "/img/FriendsPlus/Page25/Key/E3answerKey.png",
  //     component: T6v2,
  //     inputSize: 93,

  //     stylesTextInput: {
  //       fontSize: "24px",
  //       background: "transparent",
  //       textAlign: "center",
  //       borderStyle: "dotted",
  //       fontWeight:700,
  //     },
  //     titleQuestion: [
  //       {

  //         title: `<div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  //         3
  //     </div>        <div style='background:rgb(250,235,125);padding:5px 10px;border-radius:10px;text-align: center; '>
  //         <span>Số
  //         </span>
  //         </div>
  //         <div style='margin-left:5px;margin-top:5px'>
  //         ?
  //         </div>
  //         </div>
  //         </div>`,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     maxLength:8,
  //     questionImage: [],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `

  //         <div style='margin-top:-10px'>
  //         <div style='position:relative'>
  //         <div>
  //          <img style='width:30cm' src='img/FriendsPlus/Page25/E3/1.jpg' />
  //           </div>
  //         <div style='position:absolute;top:93px;left:470px;'>
  //           <input/>
  //             </div>
  //         <div style='position:absolute;top:224px;left:328px;'>
  //           <input/>
  //             </div>
  //         <div style='position:absolute;top:380px;left:235px;'>
  //           <input/>
  //              </div>
  //         <div style='position:absolute;top:540px;left:192px;'>
  //           <input/>
  //               </div>
  //         </div>
  //         </div>

  //         `,
  //         answer: [
  //           "7", "5 000 | 5000", "700", "90 000 | 90000",
  //         ],
  //       },
  //     ],
  //   },
  //   4: {
  //     unit: "Unit Starter",
  //     id: "FP8-WB-demo-2023-US-P8-E4",
  //     audio: "",
  //     exerciseKey: "/img/FriendsPlus/Page25/Key/E4answerKey.png",
  //     component: T6v2,
  //     textareaStyle: { width: 600 },
  //     inputSize: 200,
  //     stylesTextInput: {
  //       fontSize: "28px",
  //       background: "transparent",
  //       textAlign: "center",
  //       borderStyle: "dotted",
  //       fontWeight:700,
  //     },
  //     titleQuestion: [
  //       {

  //         title: `
  //         <div style='display:flex'>
  //         <div style="background-color: rgb(61, 184, 187); border-radius: 50%; color: white; width: 39px; height: 39px; text-align: center; line-height: 39px;margin-right:10px">
  //         4
  //     </div>
  //     Trong bốn ngày đầu của tuần chiến dịch tiêm vắc-xin phòng COVID-19, thành phố A đã tiêm được
  //         số liều vắc-xin như sau:
  //         </div>

  //         `,
  //         color: "rgb(28, 192, 217)",
  //       },
  //     ],
  //     questionImage: [],
  //     isHiddenCheck: true,
  //     questions: [
  //       {
  //         title: `
  //         <div style='display:flex'>
  //         <div style='line-height:2'>
  //         Thứ Hai: 36 785 liều vắc-xin <br>
  //         Thứ Tư: 37 243 liều vắc-xin
  //         </div>
  //         <div style='margin-left:50px;line-height:2'>
  //         Thứ Ba: 35 952 liều vắc-xin <br>
  //         Thứ Năm: 20 419 liều vắc-xin
  //         </div>
  //         </div>

  //         <div style='margin-top:10px;line-height:2.5;width:1200px'>
  //         <div style='display:flex'>
  //         a)
  //         <div style='margin-left:10px'>
  //         Ngày nào thành phố A tiêm được nhiều liều vắc-xin nhất? <br> Ngày nào thành phố A tiêm được
  //         ít liều vắc-xin nhất?
  //         </div>
  //         <div style='margin-left:10px'>
  //        <input/> <br> <input/>
  //         </div>
  //         </div>
  //         <div style='display:flex'>
  //         b)	 <div style='margin-left:10px'>
  //         Viết tên các ngày theo thứ tự có số liều vắc-xin đã tiêm được từ ít nhất đến nhiều nhất. <br>
  //         <div style='word-spacing:5px'>
  //        <span> Thứ: #</span><span> Thứ: #</span><span> Thứ: #</span><span> Thứ: #</span>

  //         </div>

  //         </div>
  //         </div>
  //         </div>

  //         `,
  //         answer: [
  //         `Thứ Năm`,`Thứ Ba`,`Ba`,`Hai`,`Tư`,`Năm`,
  //         ],
  //       },
  //     ],
  //   },
  //   5:{
  //     // Exercise num
  //     unit: "Unit 2",
  //     id: "SB7-U2-P57-E2",
  //     audio: "",
  //     video: "",

  //     exerciseKey: "/img/FriendsPlus/Page25/Key/E5answerKey.png",
  //     titleQuestion: [
  //       {
  //         num: "2",
  //         title: "Match 1–6 with a–f. Listen and check.",
  //         color: "#2E479B",
  //       },
  //     ],
  //     component: MatchDots,
  //     question: {
  //       DrawLines: {
  //         // multipleLine: true,
  //         boxMatch: [
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "17px",
  //               left: "165px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //0
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "52px",
  //               left: "277px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //1
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "89px",
  //               left: "269px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //2
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "123px",
  //               left: "276px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //3
  //           {
  //             boxMatchStyle: {
  //               position: "absolute",
  //               top: "159px",
  //               left: "367px",
  //               width: 30,
  //               height: 30,
  //               // backgroundColor: "white",
  //               border: "1px solid",
  //               borderRadius: "50%",
  //             },
  //           }, //4

  //         ],
  //         answers: [],
  //         initialValue: ['0-1'],
  //       },
  //       Layout: `
  //         <div style='display:flex;font-size:24px'>
  //             <div >
  //                 <b>1</b> I’m afraid …<br>
  //                 <b>2</b> His phone’s ringing, …<br>
  //                 <b>3</b> Wait! Wait! Please, …<br>
  //                 <b>4</b> Sorry, I can’t hear you.<br>
  //                 <b>5</b> Oh, I need to top up my
  //                   phone. <br>
  //                 <b>6</b> Hello, is that Susan?<br>
  //             </div>
  //             <div style='margin-left:130px'>
  //                 <b>a </b> I haven’t got any credit.<br>
  //                 <b>b </b> … but he’s not answering<br>
  //                 <b>c </b> Can you speak up?<br>
  //                 <b>d </b> … you’ve got the wrong
  //                 number.<br>
  // <b>e </b> … don’t hang up.<br>
  //                 <b>f </b> No, it’s Janet.<br>
  //             </div>
  //         </div>
  //           <input id='0' type= 'boxMatch' />
  //           <input id='1' type= 'boxMatch' />
  //           <input id='2' type= 'boxMatch' />
  //           <input id='3' type= 'boxMatch' />

  //       `,
  //     },
  //   },
};

export default json;
